import { render } from "./currency-settings.vue?vue&type=template&id=14b71904"
import script from "./currency-settings.vue?vue&type=script&lang=js"
export * from "./currency-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__